import useSWR from 'swr';

const fetcher = url => fetch(url).then(r => r.json());

export default function useNavigationItems() {
  const { data, error, isLoading } = useSWR('/navigation/menu/top/', fetcher);

  return {
    navigationItems: data,
    isLoading,
    isError: error
  };
}
